<form [formGroup]="form">
  <div class="form-group" style="display: flex; gap: 1rem">
    <div class="p-field">
      <p-floatLabel variant="in">
        <p-dropdown
          formControlName="examType"
          [options]="examTypes"
          optionLabel="label"
          optionValue="value"
          inputId="examType"
        />
        <label for="examTypes">Prüfung</label>
      </p-floatLabel>
    </div>

    <div class="p-field">
      <p-floatLabel variant="in">
        <p-inputNumber
          formControlName="examResult"
          inputId="result"
          mode="decimal"
          [minFractionDigits]="1"
          [maxFractionDigits]="1"
        />
        <label for="examResult">Ergebnis</label>
      </p-floatLabel>
    </div>
  </div>
  <div class="form-buttons">
    <button
      pButton
      type="button"
      label="Abbrechen"
      class="p-button-text"
      (click)="cancel()"
    ></button>
    <button
      pButton
      type="button"
      label="Speichern"
      [disabled]="form.invalid"
      (click)="submit()"
    ></button>
  </div>
</form>
